import * as React from "react";

const LifestylePage : React.FC = () => {
    return (
        <div className={"lifestyle"}>
            <div>
                <img src={"/images/header_lifestyle.png"} className={"header"} alt={"通院で直せる痔の治療 宮岡クリニックでは、専門性を生かし、胃、大腸、肛門の治療に特に力を注いでいます。"}/>
            </div>
            <div style={{margin: "20px"}}>
                <p>
                生活習慣病はどれも初期には症状がまったくありません。気づかないうちに進行し、脳卒中などになったときに初めてわかることも多くあります。早いうちに検査を行い、生活習慣の改善や治療を行いましょう。
                </p>

                <h1>高血圧</h1>
                <p>
                家庭血圧が135/85mmHg以上を高血圧といいます。血圧が高いと、脳卒中（脳梗塞・脳出血）や心筋梗塞や腎臓病のリスクがあがります。これを予防するために血圧はなるべく低く保つ必要があります。減塩・運動習慣が必要ですが、これだけでは血圧が下がらない方も多くいます。そのような方は薬により血圧を下げ、脳・心臓・腎臓を守っていく必要があります。
                </p>

                <h1>脂質異常症</h1>
                <p>
                以前は高脂血症と呼ばれていたものです。中性脂肪やLDLコレステロール（悪玉コレステロール）が高く、HDLコレステロール（善玉コレステロール）が低いことをさします。脂質異常症があると体中の血管が硬く狭くなります。脳梗塞、心筋梗塞、腎臓病の原因となります。
                </p>

                <h1>糖尿病</h1>
                <p>
                    血糖はインスリンというホルモンで調整されています。過食、肥満、運動不足などさまざまな原因でインスリンの働きが悪くなり、血糖が高い状態が続いている状態が糖尿病です。血糖は体内の血管に障害を与えます。初期には全く症状はありませんが、糖尿病が進行すると視力低下・腎機能低下・指の壊死などが起きます。また心筋梗塞・脳梗塞のリスクが高まります。症状のない初期に治療を開始することでこれらを予防していくことが大切です。
                </p>
            </div>
            <div className={"link"}>
                <a href={"/"}>トップページへ</a>
            </div>
        </div>
    );
}

export default LifestylePage;
